import { useState, useEffect, useRef } from 'react';
import queryString from 'query-string';
import styles from '../../styles/report-tracking/ReportsTable.module.scss';
import { connect } from 'react-redux';
import * as actions from '../../actions/reportTrackingAction';
import ReportServicePopup from './ReportServicePopup';
import { formatDate } from '../../utils/helper';
import ReportFields from '../../services/ReportFields';
import { PopoverBody, UncontrolledPopover } from 'reactstrap';
import ToolTip from '../library/ToolTip';
import {
  SearchIcon,
  CloseButtonCircleFillIcon,
  InfoCircleFilledIcon,
  CheckmarkIcon,
  HalfCirlcleIcon,
  FlagFilledIcon,
  ClockIcon,
  CheckIcon,
  ChevronUpDownArrowsIcon,
  ChevronRightIcon,
} from '../../services/SvgLibrary';
import File from '../library/File';
import UserSelect from '../user/UserSelect'
import parse from 'html-react-parser';

export const compareDict = (a, b) => {
  if (parseInt(a.law_number) < parseInt(b.law_number)) return -1;
  if (parseInt(a.law_number) > parseInt(b.law_number)) return 1;
  return 0;
}

export const localLawSort = lawArray => {
  let yearDict = {};
  let newLawArray = [];

  lawArray.forEach(ll => {
    if (yearDict[ll['year']]) {
      yearDict[ll['year']].push(ll);
    } else {
      yearDict[ll['year']] = [ll];
    }
  });
  Object.keys(yearDict).forEach(key => {
    let sortedYearLocalLaws = yearDict[key].sort(compareDict);
    newLawArray = newLawArray.concat(sortedYearLocalLaws);
  });
  return newLawArray;
}
const ReportsTable = props => {
  const tableContainerRef = useRef(null);
  const dropdownRef = useRef(null);
  const [state, setState] = useState({
    /* UI */
    isDropdownOpen: false,
    screenWidth: window.innerWidth,
    isExportDropdownOpen: false,

    /* filter checkboxes and date filters */
    filterCombination: {
      completeFilter: true,
      displayMilestones: true,
      displayReports: true,
      fromDate: '',
      pastDueFilter: true,
      receivedFilter: true,
      searchFiles: false,
      toDate: '',
      upcomingFilter: true,
    },
    searchAgency: '',
    searchAll: '',
    searchCommittee: '',
    searchDivision:  '',
    searchTitle:     '',
    searchLaw: '',
  
    /* sorting */
    selectedSortBy:   'Relevance',
    selectedSortOrder:'Ascending',
    sortBy:           '',
    sortFields: [
      { title: 'Relevance',     field: ''              },
      { title: 'Division',      field: 'division'      },
      { title: 'Errors',        field: 'errors'        },
      { title: 'Last Received', field: 'last_received' },
      { title: 'Next Due',      field: 'next_due'      },
      { title: 'Op Req Title',  field: 'title'         },
    ],
  
    toggleFilter: false,
  });
  const [opRequests, setOpRequests] = useState([]);
  const [open, setOpen] = useState(false);
  const [openRows, setOpenRows] = useState({});


  const toggleRow = id =>
    setOpenRows(prev => ({ ...prev, [id]: !prev[id] }));

  
  useEffect(() => {
    // Get all the reports
    const urlReportFilter = queryString.parse(window.location.search);
    if (props.allReports.length === 0) {
      let isMyTasks = window.location.href.includes('/myTasks/myOpReqs')
      if (
        urlReportFilter.filter
      ) {
        let filterCombo = {
          completeFilter: false,
          fromDate: '',
          toDate: '',
          displayMilestones: true,
          displayReports: true,
          fromDate : '',
          pastDueFilter: urlReportFilter.filter === 'past' ? true : false,
          receivedFilter: false,
          searchFiles: true,
          toDate : '',
          upcomingFilter: urlReportFilter.filter === 'upcoming' ? true : false,
        }
        onGetOpReqSearchResult(isMyTasks, filterCombo);
        setState(prevState => ({
          ...prevState,
          filterCombination: filterCombo
        }))
      } else {
        props.getAllReports(window.location.href.includes(isMyTasks));
      }
    }
  }, [])

  useEffect(() => {
    const onScroll = (e) => {
      const scrollPosition = e.target.scrollHeight - e.target.scrollTop;
      if (scrollPosition < 1000 && props.nextAPI && !props.isLoading) {
        props.loadMoreReports(props.nextAPI);
      }
    };

    
    const tableContainerNode = tableContainerRef.current;
    if (tableContainerNode) {
      tableContainerNode
      .addEventListener('scroll', onScroll, false);
    }
    window.addEventListener('resize', () => {
      setState(prevState => ({ ...prevState, screenWidth: window.innerWidth }));
    });
    

    // designed to respond to clicks outside of a certain element. If a click
    // event occurs outside of the dropdown it will call closeDropdown to close the dropdown.
    function handleClickOutside(e) {
      let sortMenuButton = document.getElementById('sortMenuDropdown');
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        if (sortMenuButton && !sortMenuButton.contains(e.target)) {
          setState(prevState => ({ ...prevState, isDropdownOpen: false }));
        }
      }
    };
    window.addEventListener('mousedown', handleFilterClick);
    document.addEventListener('click', handleClickOutside);
    let highlightedOpReqs = applyHighlights(props.allReports, props.highlights);
    setOpRequests(highlightedOpReqs);


    return () => {
      if (tableContainerNode) {
        tableContainerRef.current?.removeEventListener('scroll', onScroll);
      }
      document.removeEventListener('mousedown', handleFilterClick);
      document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [props.allReports, props.nextAPI, props.isLoading])

  useEffect(() => {
    onGetOpReqSearchResult();
  }, [state.sortBy, state.selectedSortBy, state.selectedSortOrder]);

  const handleFilterClick = e => {
    let dropdown = document.getElementById('filter-dropdown');
    if (dropdown) {
      let isInDropdown = dropdown.contains(e.target);
      if (!isInDropdown && state.toggleFilter) {
        setState(prevState => ({ ...prevState, toggleFilter: false }));
      }
    }
  };

  // determins the current sort direction and field, then toggling the sort direction,
  // updating the sortBy field, and finally updating the component state and triggering
  // a refresh of the data with the new sort parameters
  const onColumnClick = (column, title) => {
    let selectedSortOrder = '';
    let sortBy = '';
    let selectedSortBy = '';
    if (title !== state.selectedSortBy) {
      selectedSortOrder = 'Ascending';
      sortBy = column;
      selectedSortBy = title;
    } else {
      const direction =
        state.sortBy[0] === '-' ? 'Descending' : 'Ascending';
      const field =
        state.sortBy[0] === '-'
          ? state.sortBy.substring(1)
          : state.sortBy;
      selectedSortOrder =
        direction === 'Descending' ? 'Ascending' : 'Descending';
      sortBy = direction === 'Descending' ? field : `-${field}`;
      selectedSortBy = title;
    }

    setState(prevState =>
    ({
      ...prevState,
      sortBy,
      selectedSortBy,
      selectedSortOrder,
      searchResultsDisplay: false,
    })
    );
  };

  // toggles the isDropdownOpen state, which presumably controls whether
  // a dropdown menu is open or no
  const toggleDropdown = (value) => {
    setState(prevState => ({ ...prevState, isDropdownOpen: value }));
  };

  const toggleExportDropdown = (value) => {
    setState(prevState => ({ ...prevState, isExportDropdownOpen: value }));
  };

  // This function is counting the number of filters that are currently activated.
  const countChecked = () => {
    const filterKeys = [
      'completeFilter',
      'receivedFilter',
      'upcomingFilter',
      'pastDueFilter',
      'toDate',
      'fromDate'
    ];
    let count = 0;
    filterKeys.forEach(key => {
      if (state.filterCombination[key]) {
        count++;
      }
    });
    return count;
  };

  const onKeyPress = e => {
    if (e.key === 'Enter') {
      onGetOpReqSearchResult(e.target.value);
    }
  };

  // Trigger the action to search based on committee or keyword
  const onGetOpReqSearchResult = (value = null, filter = null) => {
    let {
      sortBy,
      searchCommittee,
      searchTitle,
      searchDivision,
      searchAgency,
      searchLaw,
      searchAll,
      filterCombination,
    } = state;

    if (filter) {
      filterCombination = filter
    }


    if (['committee', 'division', 'agency'].includes(state.currentSearchFilter) && value) {
      if (state.currentSearchFilter === 'committee') {
        searchCommittee = value
        setState(prevState => ({ ...prevState, searchCommittee: value, searchResultsDisplay: true }));
      } else if (state.currentSearchFilter === 'division') {
        setState(prevState => ({ ...prevState, searchDivision: value, searchResultsDisplay: true }));
        searchDivision = value
      } else if (state.currentSearchFilter === 'agency') {
        setState(prevState => ({ ...prevState, searchAgency: value, searchResultsDisplay: true }));
        searchAgency = value
      }
    } else {
      setState(prevState => ({ ...prevState, searchResultsDisplay: true }));
    }
    
    
    
    props.searchReports(
      sortBy,
      searchCommittee,
      searchTitle,
      searchDivision,
      searchAgency,
      searchLaw,
      searchAll,
      filterCombination,
      window.location.href.includes('/myOpReqs'),
      true
    );


  };

  const onClearFilter = () => {
    setState(prevState => ({
      ...prevState,
      searchAgency: '',
      searchAll: '',
      searchCommittee: '',
      searchDivision: '',
      searchLaw: '',
      searchResultsDisplay: false,
      searchTitle: '',
      sortBy: '',
    }));
    props.getAllReports(window.location.href.includes('/myOpReqs'));
  };

  const generateSearchBox = () => {
    const { isLoading, } = props;

    return (
      <div className={styles['report-search']}>
        <div className={styles['search-box']}>
          <SearchIcon
            width='24'
            height='24'
            onClickFunction={() => onGetOpReqSearchResult()}
            classNameProp={styles['search-button']}
          />
            <input
              className='form-control'
              type='text'
              value={state.searchAll}
              placeholder='Search'
              onChange={e => {
                setState(prevState => ({ ...prevState, searchAll: e.target.value }))
              }}
              onKeyUp={onKeyPress}
            />
          {isLoading && (
            <span className={styles['search-loading']}>
              <div className='spinner-border text-secondary' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </span>
          )}
          {state.searchResultsDisplay && !isLoading && (
            <CloseButtonCircleFillIcon
              width='16'
              height='16'
              fill='currentColor'
              onClickFunction={onClearFilter}
              classNameProp={`${styles['search-button']}`}
            />
          )}
        </div>
      </div>
    );
  };

  const generateFileSearchToggle = () => {
    return (
      <section className={styles['file-search-toggle-section']}>
        <label
          className={`${styles['search-files-label']}`}>
          Search Files
          <input
            type='checkbox'
            checked={state.filterCombination.searchFiles}
            onChange={() => {
              setState(prevState => {
                prevState.filterCombination['searchFiles'] =
                  !prevState.filterCombination['searchFiles'];
                return {
                  ...prevState,
                  filterCombination: prevState.filterCombination,
                };
              });
            }}
          />
          <span
            className={`${styles['color-filter-checkmark']}`}></span>
          <InfoCircleFilledIcon
            classNameProp={styles['filter-popover-user-guide']}
            idProp='file-search'
          />
        </label>
        <UncontrolledPopover
          placement='left'
          target={'file-search'}
          fade={false}
          trigger='hover'>
          <PopoverBody>
            Searching files will typically return more results, especially when searching numbers.
            It is recommended to turn this off if searching for a specific local law.
          </PopoverBody>
        </UncontrolledPopover>
      </section>
    )
  }

  const { allReports, isLoading, selectTargetDayForReports, userProfile, agencies, committees } =
    props;

  const divisions = ReportFields.find(
    item => item.field === 'division'
  ).options;

  const isCMStaff =
    userProfile.role.includes('Council Member') ||
    userProfile.under_council_member;

  if (isCMStaff) {
    state.sortFields = state.sortFields.filter(
      field => field.field != 'errors'
    );
  }

  const DROP_SUFFIXES = new Set(['partial', 'full', 'keyword', 'search']);

  function replaceAtIndex(_string, _index, _keyword) {
    let endingCharIndex = _string
      .slice(_index + _keyword.length)
      .search(/[\s\b.,/#!$%^&*;:{}=\-_`~()]/g);
    let endOfKeyword =
      endingCharIndex > -1
        ? _index + _keyword.length + endingCharIndex
        : _index + _keyword.length;
    let newValue = `<strong class='highlight'>${_string.slice(
      _index,
      endOfKeyword
    )}</strong>`;
    return `${_string.substring(0, _index)}${newValue}${_string.substring(
      endOfKeyword
    )}`;
  }
    
  function highlightTerms(text) {
    let searchTerms = props.searchTerms 
    if (!searchTerms) return text;
    text = text && text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    for (let term of new Set(searchTerms.split(' '))) {
      let termRegex = new RegExp(`\\b(${term})\\w*\\b`, 'gi');
      let indexMatches = [];
      let matchFound;
      while ((matchFound = termRegex.exec(text)) != null) {
        indexMatches.unshift(matchFound.index);
      }

      for (let i = 0; i < indexMatches.length; i++) {
        text = replaceAtIndex(text, indexMatches[i], term);
      }
    }

    return text;
  }

  function applyHighlights(reports, highlights) {
    const updated = reports.map(r => ({ ...r }));
  
    for (const [opReqId, fieldMap] of Object.entries(highlights || {})) {
      const opReq = updated.find(r => String(r.id) === String(opReqId));
      if (!opReq) continue;
  

      for (const [rawPath, snippets] of Object.entries(fieldMap || {})) {
        if (!snippets || !snippets.length) continue;
  
        const parts = rawPath.split(".").filter(Boolean);
        while (parts.length && DROP_SUFFIXES.has(parts[parts.length - 1])) {
          parts.pop();
        }
        if (!parts.length) continue;
  
        applyInto(opReq, parts, snippets);
      }
    }
    return updated;
  }

  function applyInto(node, parts, snippets) {
    if (node == null) return;
  
    if (Array.isArray(node)) {
      for (const item of node) applyInto(item, parts, snippets);
      return;
    }
  
    const [head, ...rest] = parts;
  
    applyInto(node[head], rest, snippets);
  }

  const opReqsDisplay =
    opRequests &&
    opRequests.map((opReq, idx) => {
      let committees = opReq.committees.map((committee, idx) => (
        <p key={idx} className={styles['report-committee']}>
          {committee.committee_name}
        </p>
      ));
      let agencies = opReq.submitting_agency
        .map(agency => agency.name)
        .join(', ');
      let opReqTitle = opReq.title;

      if (state.screenWidth > 768) {
        opReqTitle = opReq.title;
        if (state.screenWidth < 992 && opReqTitle.length > 115) {
          opReqTitle = opReqTitle.substring(0, 115) + '...';
        } else if (state.screenWidth < 1200 && opReqTitle.length > 175) {
          opReqTitle = opReqTitle.substring(0, 175) + '...';
        }
      }

      let info = opReqTitle !== opReq.title;
      let localNextDue = formatDate(opReq.next_due);
      let nextDue = new Date(localNextDue).toDateString();
      let tileClass;
      switch (opReq.status.toLowerCase()) {
        case 'upcoming':
          tileClass = styles['upcoming'];
          break;
        case 'past_due':
          tileClass = styles['past-due'];
          break;
        case 'completed':
          tileClass = styles['completed'];
          break;
        case 'received':
          tileClass = styles['received'];
          break;
        default:
          tileClass = '';
          break;
      }
      let statusText = opReq.status.replace(/_/g, ' ');
      
      let allLocalLaws = opReq.legislation
      let sortedLocalLaw = localLawSort(allLocalLaws)
        .map(ll => ll.full_law_number)
        .join(', ');

      return (
        <div
          key={idx}
          className={`${styles['report-block']} ${
            openRows[opReq.id] ? styles['report-open'] : ''
          }`}
          onClick={() => {
            selectTargetDayForReports([opReq]);
            document.body.style.overflow = 'hidden';
          }}>
          {state.screenWidth > 768 && (
            <>
              <div className={styles['row-content']}>
                <div className={styles['report-first-block']}>
                  <div
                    className={`${styles['report-sidelabel-container']} ${tileClass}`}>
                    <p className={`${styles['report-sidelabel-text']}`}>
                      {parse(highlightTerms(statusText))}
                    </p>
                  </div>
                  <div>
                    <div className={styles['report-sub-title']}>
                      Next Due Date
                    </div>
                    <div className={styles['report-last-date']}>
                      {opReq.next_due ? (
                        <>
                          <div>{nextDue.substr(4, 6).toUpperCase()}</div>
                          <div className={styles['report-last-date-year']}>
                            {parse(nextDue.substr(11))}
                          </div>
                        </>
                      ) : (
                        'N/A'
                      )}
                    </div>
                  </div>
                </div>
                <div className={styles['report-middle-block']}>
                  <div className={styles['report-title']}>
                    {parse(highlightTerms(opReqTitle))}
                    {info ? (
                      <ToolTip
                        id={`report-${opReq.id}`}
                        target={`report-${opReq.id}`}
                        text={parse(opReq.title)}
                      />
                    ) : (
                      ''
                    )}
                  </div>
                  <div>
                    {sortedLocalLaw && (
                      <>
                        <span>{parse(highlightTerms(sortedLocalLaw))}</span>
                        <br />
                      </>
                    )}
                    <span className={styles['report-sub-title']}>Type: </span>
                    <span className='capitalize'>{opReq.tracker_type}</span>
                    <br />
                    <span className={styles['report-sub-title']}>Agency: </span>
                    <span>{parse(highlightTerms(agencies))}</span>
                  </div>
                </div>
                <div className={styles['report-end-block']}>
                  <div className={styles['report-date-padding']}>
                    Last Received {opReq.last_received
                      ? formatDate(parse(highlightTerms(opReq.last_received)))
                      : 'N/A'}
                  </div>
                  <div className={styles['report-committees']}>
                    <span>Committees: </span>
                    {committees.map((committee, idx) => (
                      <span key={idx} className={styles['report-committee']}>
                        {parse(highlightTerms(committee.props.children))}
                      </span>
                    ))}
                  </div>

                </div>
                <ChevronRightIcon
                  width='20'
                  height='20'
                  classNameProp={styles['report-block-arrow']}
                />
              </div>

              {opReq.attachment_match?.length > 0 && (
                <>
                  <div
                    className={styles['file-bar']}
                    onClick={e => {
                      e.stopPropagation();
                      toggleRow(opReq.id);
                    }}
                  >
                    <span className={styles['file-bar-text']}>
                      {openRows[opReq.id] ? 'Hide Matching Files' : 'Show Matching Files'}
                    </span>

                    <ChevronRightIcon
                      width={18}
                      height={18}
                      classNameProp={`${styles['file-bar-arrow']} ${
                        openRows[opReq.id] ? styles['open'] : ''
                      }`}
                    />
                  </div>

                  <div className={styles['file-list']}>
                    {opReq.attachment_match.map(file => (
                      <File
                        key={file.id}
                        id={file.id}
                        file={file}
                        fileName={file.file_name}
                        highlighted={file.highlighted}
                        getFileAndDownload={() => window.open(file.file, '_blank')}
                      />
                    ))}
                  </div>
                </>
              )}            
            </>
          )}
          {state.screenWidth <= 768 && (
            <>
              <div className={styles['row-content-mobile']}> 
                <div
                  className={`${styles['report-sidelabel-container']} ${tileClass}`}>
                  <p className={`${styles['report-sidelabel-text']}`}>
                    {statusText}
                  </p>
                </div>
                <div style={{ display: 'block', float: 'left' }}>
                  <div>
                    <div className={styles['report-sub-title-mobile']}>
                      Op Req Title:
                    </div>
                    <div className={styles['report-sub-field-mobile']}>
                      {parse(opReqTitle)}
                      {info ? (
                        <ToolTip
                          id={`report-${opReq.id}`}
                          target={`report-${opReq.id}`}
                          text={parse(highlightTerms(opReq.title))}
                        />
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                  <div>
                    <div className={styles['report-sub-title-mobile']}>
                      Type:
                    </div>
                    <div className={styles['report-sub-field-mobile']}>
                      <span className='capitalize'>{parse(highlightTerms(opReq.tracker_type))}</span>
                    </div>
                  </div>
                  {sortedLocalLaw && (
                    <div>
                      <div className={styles['report-sub-title-mobile']}>
                        Local Law:
                      </div>
                      <div className={styles['report-sub-field-mobile']}>
                        {sortedLocalLaw}
                      </div>
                    </div>
                  )}
                  <div>
                    <div className={styles['report-sub-title-mobile']}>
                      Agency:
                    </div>
                    <div className={styles['report-sub-field-mobile']}>
                      {parse(highlightTerms(agencies))}
                    </div>
                  </div>
                  <div>
                    <div
                      className={styles['report-sub-title-mobile-committee']}>
                      Committee:
                    </div>
                    <div className={styles['report-sub-field-mobile']}>
                      {committees.map((committee, idx) => (
                        <span key={idx} className={styles['report-committee']}>
                          {parse(highlightTerms(committee.props.children))}
                        </span>
                      ))}
                    </div>
                  </div>
                  <div>
                    <div className={styles['mobile-date']}>
                      Last Received
                      <span>
                        {opReq.last_received
                          ? formatDate(opReq.last_received)
                          : 'N/A'}
                      </span>
                    </div>
                    <div className={styles['mobile-date']}>
                      Next Due Date
                      <span>
                        {opReq.next_due ? formatDate(opReq.next_due) : 'N/A'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>          
              {opReq.attachment_match?.length > 0 && (
                <>
                  <div
                    className={styles['file-bar']}
                    onClick={e => {
                      e.stopPropagation();
                      toggleRow(opReq.id);
                    }}
                  >
                    <span className={styles['file-bar-text']}>
                      {openRows[opReq.id] ? 'Hide Matching Files'
                                          : 'Show Matching Files'}
                    </span>

                    <ChevronRightIcon
                      width={18}
                      height={18}
                      classNameProp={`${styles['file-bar-arrow']} ${
                        openRows[opReq.id] ? styles.open : ''
                      }`}
                    />
                  </div>
                
                

                  <div className={styles['file-list']}>
                    {opReq.attachment_match.map(file => (
                      <File
                        key={file.id}
                        id={file.id}
                        file={file}
                        fileName={file.file_name}
                        highlighted={file.highlighted}
                        getFileAndDownload={() => window.open(file.file, '_blank')}
                      />
                    ))}
                  </div>
                </>
              )}  
            </>
          )}
        </div>

      );
    });

  const searchFields = [
    {
      title: 'Agency',
      field: 'agency',
    },
    {
      title: 'Committee',
      field: 'committee',
    },
    {
      title: 'Division',
      field: 'division',
    },
    {
      title: 'Op Req Title',
      field: 'title',
    },
  ];

  const filterFields = [
    {
      title: 'Agency',
      field: 'agency',
    },
    {
      title: 'Committee',
      field: 'committee',
    },
    {
      title: 'Division',
      field: 'division',
    },
    {
      title: 'Op Req Title',
      field: 'title',
    },
  ]

  return (
    <div ref={tableContainerRef} className='main-container' id='main-container'>
      <div className={styles['reports-search-container']}>
        {generateSearchBox()}
        <div className={styles['file-search-toggle']}>
          {generateFileSearchToggle()}
        </div>
        <div className={styles['report-sort-and-filter-container']}>
          <span style={{ display: 'flex' }}>
            Tracker List&nbsp;
            <InfoCircleFilledIcon
              classNameProp={styles['user-guide-field-icon']}
              idProp='tracker'
            />
            <UncontrolledPopover
              placement='left'
              target={'tracker'}
              fade={false}
              trigger='hover'>
              <PopoverBody>
                A tracker monitors reports, or milestones, over all due dates
                mandated by a law or part of a law.
              </PopoverBody>
            </UncontrolledPopover>
          </span>
          <span className={styles['sort-filter-flex']}>
            {
              userProfile.permissions.reportTracking.view_report &&
              <div className='dropdown'>
                <button
                  type='button'
                  className={`btn dropdown-toggle d-flex align-items-center se-1 ${styles['filter-label']}`}
                  data-bs-toggle="dropdown" aria-expanded="false"
                  id='exportDropdownButton'
                  onClick={() => toggleExportDropdown(true)}>
                  Export Trackers
                </button>
                <ul className={`dropdown-menu ${
                      state.isExportDropdownOpen ? 'show' : ''
                    } ${styles['dropdown-menu']} ${styles['filter']}`}
                    aria-labelledby='exportDropdownButton'>
                  { state.searchResultsDisplay && !isLoading &&
                    <li className='dropdown-item p-2' role='button' disabled={state.searchResultsDisplay && !isLoading} onClick={()=>{
                      props.exportSetTrackers(
                        state.sortBy,
                        state.searchCommittee,
                        state.searchTitle,
                        state.searchDivision,
                        state.searchAgency,
                        state.searchLaw,
                        state.searchAll,
                        state.filterCombination,
                        window.location.href.includes('/myOpReqs')
                      );
                    }}>Export Searched Trackers</li>
                  }
                  <li className='dropdown-item p-2' role='button' onClick={()=>{
                    props.exportSetTrackers()
                  }}>Export All Trackers</li>
                </ul>
              </div>
            }
            <span className={styles['filter-label']}>Sort by</span>
            <div
              className={`dropdown ${state.isDropdownOpen ? 'show' : ''
                }`}
              ref={dropdownRef}>
              <button
                className={`btn dropdown-toggle d-flex align-items-center ${styles['dropdown-toggle']}`}
                type='button'
                id='dropdownMenuButton1'
                onClick={() => {
                  toggleDropdown(true);
                }}
                aria-haspopup='true'
                aria-expanded={state.isDropdownOpen}>
                {state.selectedSortBy}
                <ChevronUpDownArrowsIcon
                  width='15'
                  height='15'
                  classNameProps={styles['chevron-icon']}
                />
              </button>
              <ul
                className={`dropdown-menu ${state.isDropdownOpen ? 'show' : ''
                  } ${styles['dropdown-menu']} ${styles['filter']}`}
                id='sortMenuDropdown'
                aria-labelledby='dropdownMenuButton1'>
                {state.sortFields.map((c, idx) => (
                  <li key={idx}>
                    <a
                      className={`dropdown-item ${styles['status-dropdown-item']}`}
                      href='#'
                      onClick={() => {
                        if (state.selectedSortBy !== c.title) {
                          onColumnClick(c.field, c.title);
                        }
                        toggleDropdown(false);
                      }}>
                      {c.title}
                      {state.selectedSortBy === c.title && (
                        <CheckIcon
                          classNameProp={styles['dropdown-checkmark']}
                        />
                      )}
                    </a>
                  </li>
                ))}
                <li>
                  <hr className='dropdown-divider' />
                </li>
                {/* Sort direction */}
                {['Ascending', 'Descending'].map((sort_direction, idx) => {
                  return (
                    <li key={`sort-direction-${idx}`} className={`${state.sortBy === '' ? styles['disabled'] : ''}`}>
                      <a
                        className={`dropdown-item ${styles['status-dropdown-item']}`}
                        onClick={e => {
                          if(state.sortBy) {
                            onColumnClick(
                              state.sortBy,
                              state.selectedSortBy
                            );
                          }
                        }}>
                        {sort_direction}
                        {state.selectedSortOrder === sort_direction && (
                          <CheckIcon
                            classNameProp={styles['dropdown-checkmark']}
                          />
                        )}
                      </a>
                    </li>
                  )
                })}
              </ul>
            </div>
            <div>
              <button
                className={`btn dropdown-toggle ${styles['filter-label']}`}
                id='report-list-status'
                type='button'>
                Filter
                <span
                  className='badge'
                  style={{ color: '#002164', backgroundColor: '#c0d1f3' }}>
                  {countChecked()}
                </span>
              </button>
              <UncontrolledPopover
                innerClassName={styles['popover-container']}
                className={styles['popover-outer-container']}
                trigger='legacy'
                placement='bottom'
                target='report-list-status'>
                <PopoverBody
                  className={styles['list-filter-dropdown-wrapper']}>
                  <div className={styles['filter-row']}>
                    <section className={styles['filter-col']}>
                      <h6 className='dropdown-header pb-0'>Type</h6>
                      <label
                        className={`${styles['color-filter-container']} ${styles['completed']}`}>
                        Report
                        <input
                          type='checkbox'
                          checked={state.filterCombination.displayReports}
                          onChange={() => {
                            setState(prevState => {
                              prevState.filterCombination['displayReports'] =
                                !prevState.filterCombination['displayReports'];
                              return {
                                ...prevState,
                                filterCombination: prevState.filterCombination,
                              };
                            });
                          }}
                        />
                        <span
                          className={`${styles['color-filter-checkmark']} ${styles['completed']}`}></span>
                        <InfoCircleFilledIcon
                          classNameProp={styles['filter-popover-user-guide']}
                          idProp='report'
                        />
                      </label>

                      <label
                        className={`${styles['color-filter-container']} ${styles['completed']}`}>
                        Milestone
                        <input
                          type='checkbox'
                          checked={state.filterCombination.displayMilestones}
                          onChange={() => {
                            setState(prevState => {
                              prevState.filterCombination['displayMilestones'] =
                                !prevState.filterCombination['displayMilestones'];
                              return {
                                ...prevState,
                                filterCombination: prevState.filterCombination,
                              };
                            });
                          }}
                        />
                        <span
                          className={`${styles['color-filter-checkmark']} ${styles['completed']}`}></span>
                        <InfoCircleFilledIcon
                          classNameProp={styles['filter-popover-user-guide']}
                          idProp='milestone'
                        />
                      </label>

                      <UncontrolledPopover
                        fade={false}
                        trigger='hover'
                        placement='bottom'
                        target='report'>
                        <PopoverBody>
                          <div>
                            <b>Reports:</b> Reports are usually files mandated
                            often on a periodic basis by local law.
                          </div>
                        </PopoverBody>
                      </UncontrolledPopover>

                      <UncontrolledPopover
                        fade={false}
                        trigger='hover'
                        placement='bottom'
                        target='milestone'>
                        <PopoverBody>
                          <div>
                            <b>Milestones:</b> Milestones are one time goals that
                            are to be met.
                          </div>
                        </PopoverBody>
                      </UncontrolledPopover>
                      <hr className='dropdown-divider' />
                      <h6 className='dropdown-header pb-0'>Progress</h6>
                      <label
                        className={`${styles['color-filter-container']} ${styles['completed']}`}>
                        <CheckmarkIcon
                          width='30px'
                          height='20px'
                          classNameProp={styles['status-icons']}
                        />
                        Completed
                        <input
                          type='checkbox'
                          checked={state.filterCombination.completeFilter}
                          onChange={() => {
                            setState(prevState => {
                              prevState.filterCombination['completeFilter'] =
                                !prevState.filterCombination['completeFilter'];
                              return {
                                ...prevState,
                                filterCombination: prevState.filterCombination
                              };
                            });
                          }}
                        />
                        <span
                          className={`${styles['color-filter-checkmark']} ${styles['completed']}`}></span>
                        <InfoCircleFilledIcon
                          classNameProp={styles['filter-popover-user-guide']}
                          idProp='completed'
                        />
                      </label>

                      <label
                        className={`${styles['color-filter-container']} ${styles['received']}`}>
                        <HalfCirlcleIcon
                          width='30px'
                          height='20px'
                          classNameProp={styles['status-icons']}
                        />
                        Received
                        <input
                          type='checkbox'
                          checked={state.filterCombination.receivedFilter}
                          onChange={() => {
                            setState(prevState => {
                              prevState.filterCombination['receivedFilter'] =
                                !prevState.filterCombination['receivedFilter'];
                              return {
                                ...prevState,
                                filterCombination: prevState.filterCombination
                              };
                            });
                          }}
                        />
                        <span
                          className={`${styles['color-filter-checkmark']} ${styles['received']}`}></span>
                        <InfoCircleFilledIcon
                          classNameProp={styles['filter-popover-user-guide']}
                          idProp='received'
                        />
                      </label>

                      <label
                        className={`${styles['color-filter-container']} ${styles['upcoming']}`}>
                        <FlagFilledIcon
                          width='30px'
                          height='20px'
                          classNameProp={styles['status-icons']}
                        />
                        Upcoming
                        <input
                          type='checkbox'
                          checked={state.filterCombination.upcomingFilter}
                          onChange={() => {
                            setState(prevState => {
                              prevState.filterCombination['upcomingFilter'] =
                                !prevState.filterCombination['upcomingFilter'];
                              return {
                                ...prevState,
                                filterCombination: prevState.filterCombination,
                              };
                            });
                          }}
                        />
                        <span
                          className={`${styles['color-filter-checkmark']} ${styles['upcoming']}`}></span>
                        <InfoCircleFilledIcon
                          classNameProp={styles['filter-popover-user-guide']}
                          idProp='upcoming'
                        />
                      </label>

                      <label
                        className={`${styles['color-filter-container']} ${styles['past-due']}`}>
                        <ClockIcon
                          width='30px'
                          height='20px'
                          classNameProp={styles['status-icons']}
                        />
                        Past Due
                        <input
                          type='checkbox'
                          checked={state.filterCombination.pastDueFilter}
                          onChange={() => {
                            setState(prevState => {
                              prevState.filterCombination['pastDueFilter'] =
                                !prevState.filterCombination['pastDueFilter'];
                              return {
                                ...prevState,
                                filterCombination: prevState.filterCombination,
                              };
                            });
                          }}
                        />
                        <span
                          className={`${styles['color-filter-checkmark']} ${styles['past-due']}`}></span>
                        <InfoCircleFilledIcon
                          classNameProp={styles['filter-popover-user-guide']}
                          idProp='past-due'
                        />
                      </label>
                    </section>
                    
                    <section className={styles['filter-col']}>
                      <h6 className='dropdown-header pb-0'>Due Date Range</h6>
                      <label className={styles['date-padding']}>
                        From
                        <input
                          className={`form-control ${styles['input-text-area']}`}
                          type='date'
                          value={state.filterCombination['fromDate']}
                          onChange={(e) => {
                            setState(prevState => {
                              prevState.filterCombination['fromDate'] = e.target.value;
                              return {
                                ...prevState,
                                filterCombination: prevState.filterCombination,
                              };
                            });
                          }}
                        />
                      </label>
                      <label className={styles['date-padding']}>
                        To
                        <input
                          className={`form-control ${styles['input-text-area']}`}
                          type='date'
                          value={state.filterCombination['toDate']}
                          onChange={(e) => {
                            setState(prevState => {
                              prevState.filterCombination['toDate'] = e.target.value;
                              return {
                                ...prevState,
                                filterCombination: prevState.filterCombination,
                              };
                            });
                          }}
                        />
                      </label>
                    </section>

                    <section className={styles['filter-col']}>
                      <h6 className='dropdown-header pb-0'>Additional Filters</h6>
                      <div className={styles['filters-section']}>

                        <div className={styles['filter-control']}>
                          <input
                            className='form-control'
                            placeholder='Search Agencies'
                            value={state.searchAgency}
                            onChange={e => setState(p => ({ ...p, searchAgency: e.target.value }))}
                            onFocus={() => setState(p => ({ ...p, agencyFocus: true }))}
                          />
                          <UserSelect
                            options={agencies.filter(c => c.name !== 'Select Agency')}
                            search={state.searchAgency}
                            focused={state.agencyFocus}
                            handleClick={e => {
                              setState(p => ({
                                ...p,
                                searchAgency: e.target.innerText,
                                agencyFocus: false,
                              }));
                            }}
                          />
                        </div>
                      

                        <div className={styles['filter-control']}>            
                          <input
                            className='form-control'
                            placeholder='Search Committees'
                            value={state.searchCommittee}
                            onChange={e => setState(p => ({ ...p, searchCommittee: e.target.value }))}
                            onFocus={() => setState(p => ({ ...p, committeeFocus: true }))}
                          />

                          <UserSelect
                            options={committees.filter(c => c.committee_name !== 'Select Committee')}   
                            search={state.searchCommittee}
                            focused={state.committeeFocus}
                            handleClick={e => {
                              setState(p => ({
                                ...p,
                                searchCommittee: e.target.innerText,
                                committeeFocus: false,
                              }));
                            }}
                          />
                        </div>

                        <div className={styles['filter-control']}>
                          <input
                            className='form-control'
                            placeholder='Search Divisions'
                            value={state.searchDivision}
                            onChange={e => setState(p => ({ ...p, searchDivision: e.target.value }))}
                            onFocus={() => setState(p => ({ ...p, divisionFocus: true }))}
                          />
                          <UserSelect
                            options={divisions.filter(c => c.division_name !== 'Select Division')}
                            search={state.searchDivision}
                            focused={state.divisionFocus}
                            handleClick={e => {
                              setState(p => ({
                                ...p,
                                searchDivision: e.target.innerText,
                                divisionFocus: false,
                              }));
                            }}
                          />
                        </div>

                      </div>
                    </section>

                  </div>

                  <div className={styles['apply-row']}>
                    <button
                      className={styles['apply-button-filter']}
                      onClick={(e) => {
                        e.stopPropagation();
                        document.getElementById('report-list-status')?.click();
                        onGetOpReqSearchResult();
                      }}>
                      Apply Filter
                    </button>
                  </div>
                  <UncontrolledPopover
                    fade={false}
                    trigger='hover'
                    placement='bottom'
                    target='completed'>
                    <PopoverBody>
                      <div>
                        <b>Completed:</b> A Compliance Tracker whose
                        final report has been submitted with no further reports
                        due in the future, or a completed milestone.
                      </div>
                    </PopoverBody>
                  </UncontrolledPopover>

                  <UncontrolledPopover
                    fade={false}
                    trigger='hover'
                    placement='bottom'
                    target='received'>
                    <PopoverBody>
                      <div>
                        <b>Received:</b> A Compliance Tracker with a
                        report due in the future which has already been
                        received.
                      </div>
                    </PopoverBody>
                  </UncontrolledPopover>

                  <UncontrolledPopover
                    fade={false}
                    trigger='hover'
                    placement='bottom'
                    target='upcoming'>
                    <PopoverBody>
                      <div>
                        <b>Upcoming: </b> A Compliance Tracker whose most
                        recently due (past) report was received, with a future
                        report that has yet to be submitted, or a milestone
                        not yet due.
                      </div>
                    </PopoverBody>
                  </UncontrolledPopover>

                  <UncontrolledPopover
                    fade={false}
                    trigger='hover'
                    placement='bottom'
                    target='past-due'>
                    <PopoverBody>
                      <div>
                        <b>Past due:</b> A Compliance Tracker whose most
                        recently due (past) report has not been submitted with
                        future reports not submitted, or an incomplete
                        milestone past its due date.
                      </div>
                    </PopoverBody>
                  </UncontrolledPopover>
                </PopoverBody>
              </UncontrolledPopover>
            </div>
          </span>
        </div>
      </div>
      <div
        aria-hidden={!props.exportingTrackers}
        aria-modal={props.exportingTrackers}
        className={`modal fade ${props.exportingTrackers ? 'show' : ''}`}
        role='dialog'
        style={{
          display: props.exportingTrackers ? 'block' : 'none',
          backgroundColor: props.exportingTrackers ? 'rgba(0,0,0,.4)' : 'transparent',
        }}
        tabIndex='-1'>
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>Please wait...</h5>
            </div>
            <div className='modal-body'>
              <p>
                We are processing your request...
              </p>
              <p>
                You will receive your exported file by email after a few minutes.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles['report-list-container']} ${styles['opreqList']}`}>
        {allReports.length > 0 && opReqsDisplay}
      </div>
      {isLoading && (
        <div className='loading-container'>
          <img
            className='loading-image'
            src='/img/newLoadingAnimation.gif'
            alt='Loading animation'
          />
          <h3>
            Loading <span className='dot1'>.</span>
            <span className='dot2'>.</span>
            <span className='dot3'>.</span>
          </h3>
        </div>
      )}
      {allReports.length === 0 && (
        <div className={styles['no-valid-result-container']}>
          <img
            src='/../img/no-results-found.svg'
            alt='No valid results'></img>
          <p>No valid result</p>
        </div>
      )}
      {(!props.mode || props.mode === 'list') && (
        <ReportServicePopup 
          match={props.match} 
          currentMode='list' 
          highlightTerms={highlightTerms}
          
          />
      )}
    </div>
  );
}

const mapStateToProps = state => {
  //Deep copy the arrays from the state
  const committees = state.userReducer.committees
    .slice(0)
    .filter(com => com.committee_name !== 'Unassigned');
  const agencies = state.reportTrackingReducer.allAgencies.slice(0);
  return {
    userProfile: state.userReducer.userProfile,
    isLoading: state.reportTrackingReducer.isLoading,
    nextAPI: state.reportTrackingReducer.nextAPI,
    allReports: state.reportTrackingReducer.allReports,
    exportingTrackers: state.reportTrackingReducer.exportingTrackers,
    committees: committees,
    agencies: agencies,
    highlights: state.reportTrackingReducer.highlights,
    searchTerms: state.reportTrackingReducer.searchTerms,
  };
};

export default connect(mapStateToProps, actions)(ReportsTable);
